// Key used in sessionStorage to flag that the user has been sent to the
// external payment page. It lets us detect a return via the browser "back"
// button and redirect to the checkout (basket) page instead of the order page.
export const PAYMENT_IN_PROGRESS_KEY = 'paymentInProgress';

// The order the checkout has just created, kept (sessionStorage survives the
// round trip to Stripe / PayPal in the same tab) until the payment comes back.
export const PLACED_ORDER_KEY = 'placedOrder';

// Set once the provider reports the payment as taken; the thank-you page reads
// and deletes it, so it opens once per paid order.
export const CONFIRMED_ORDER_KEY = 'confirmedOrder';

// What the providers put in the return URL: our own `payment-status`
// (Stripe Checkout, PayPal) or Stripe's `redirect_status` (a wallet payment
// that needed a redirect, e.g. 3-D Secure).
export const PAYMENT_STATUS_PARAM = 'payment-status';
export const STRIPE_REDIRECT_STATUS_PARAM = 'redirect_status';
export const PAYMENT_SUCCESS_STATUSES = ['success', 'succeeded', 'processing'];
